import React from "react";
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const { t } = useTranslation("common");
  return (
    <div className="flex justify-end text-center mr-20 ">
      <p className="text-gray-400">{t("footer.label")}</p>
    </div>
  );
};

export default Footer;
